package com.anjuros.website.templates.template6.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.templates.template6.components.SectionTitle
import com.anjuros.website.templates.template6.components.Template6TestimonialCard
import com.anjuros.website.templates.template6.modules.Template6Review
import com.anjuros.website.templates.template6.modules.Template6Section
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.anjuros.website.templates.template6.styles.Template6ReviewPaddingStyle
import com.anjuros.website.templates.template6.styles.Template6ReviewStyle
import com.anjuros.website.templates.template6.styles.Template6ReviewsDotStyle
import com.anjuros.website.templates.template6.util.ResKey
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.JustifyItems
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.justifyItems
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb

@Composable
fun Template6ReviewsSection(
    modifier: Modifier = Modifier.fillMaxWidth(70.percent),
){
    Box(
        modifier = Modifier
            .id("reviews")
            .backgroundColor(rgb(248, 249, 251))
            .id(Template6Section.Testimonial.id)
            .fillMaxWidth(),
        contentAlignment = Alignment.Center
    ) {


        Template6ReviewsContent(
            modifier = modifier
        )


    }
}

@Composable
fun Template6ReviewsContent(
    modifier: Modifier
){

    var selectedPage by remember { mutableStateOf(0) }
    Box(modifier = modifier) {

        Column(
            modifier = Template6ReviewPaddingStyle.toModifier().fillMaxWidth(100.percent).fillMaxHeight()
                .align(Alignment.Center),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SectionTitle(
                title = ResKey.TEMPLATE6_REVIEWS_TITLE,
                subtitle = ResKey.TEMPLATE6_REVIEWS_SUBTITLE
            )
            TestimonialCards(selectedPage)
            TestimonialNavigation(selectedPage) {
                selectedPage = it
            }

        }

    }
}

@Composable
fun TestimonialCards(selectedPage: Int){

    val testimonial1 = listOf(Template6Review.Review1, Template6Review.Review2, Template6Review.Review3)
    val testimonial2 = listOf(Template6Review.Review4, Template6Review.Review5, Template6Review.Review6)
    val testimonial3 = listOf(Template6Review.Review7, Template6Review.Review8, Template6Review.Review9)

    val list = when(selectedPage){
        1-> testimonial1
        2-> testimonial2
        else -> testimonial3
    }
    SimpleGrid(
        modifier = Modifier.fillMaxWidth()
            .margin(top = 80.px, bottom = 40.px)
            ,
        numColumns = numColumns(base=1, lg=3)
    ) {

        list.forEach {testimonial->
            Box(modifier = Modifier.fillMaxSize()
               ,
                contentAlignment = Alignment.Center) {
                Template6TestimonialCard(
                    modifier =Template6ReviewStyle.toModifier(),
                    testimonial = testimonial
                )
            }
        }
}
    }



@Composable
fun TestimonialNavigation(
    selectedPage:Int,
    onNavigate:(Int)->Unit
){
    Row(modifier = Template6ReviewsDotStyle.toModifier(),
        horizontalArrangement = Arrangement.spacedBy(10.px),
        verticalAlignment = Alignment.CenterVertically){
        repeat(3){index->
            Box(
                modifier = Modifier
                    .cursor(Cursor.Pointer)
                    .size(12.px)
                    .borderRadius(50.px)
                    .onClick { onNavigate(index) }
                    .backgroundColor(
                        if(selectedPage==index){
                            Template6Theme.Selection.rgb
                        } else
                            Template6Theme.LightGray.rgb
                    )

            ) {}
        }
    }
}